import AxiosClient from "../../../services/axios.services";

class CompetenciesServices {
  getCompetency = (params) =>
    AxiosClient.get(
      "/api/app/carrera_competencia/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCompetencyByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_competencia/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCompetency = (data) =>
    AxiosClient.post(
      "/api/app/carrera_competencia/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCompetency = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCompetency = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_competencia/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CompetenciesServices();
